import src from "IMAGE";
export default { src, width: 499, height: 271, blurWidth: 0, blurHeight: 0};
